import React, { useEffect, useState }  from "react";
import { connect } from "react-redux";
import SummaryCard from "./components/SummaryCard";
import { Award, Heart, MessageCircleHeart, TrendingUp, GraduationCap} from "lucide-react";
import FilterToolBar from "./components/FilterToolBar";
import { recognitionFilters } from "variables/constants";
import RecognitionCard from "./components/RecognitionCard";
import ShoutoutCard from "./components/ShoutoutCard";
import {
  getRecognitionWallList
} from "../../../../redux/recognitionwall/recognitionWallState";



const Recognitions = ({
  doSearch,
  recordList,
  pagination
}) => {
  const [activeFilter, setActiveFilter] = useState("all");
  const [isShoutoutOpen, setIsShoutoutOpen] = useState(false);

  const handleOpenShoutout = () => setIsShoutoutOpen(true);
  const handleCloseShoutout = () => setIsShoutoutOpen(false);

  useEffect(() => {
    doSearch({paginate: pagination.per_page});
  }, [doSearch, pagination.per_page]);

  return (
    <div className="space-y-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <SummaryCard
            dispalyCount={12}
            description="Total Shoutouts"
            Icon={MessageCircleHeart}
            variant="purple"
          />
          <SummaryCard
            dispalyCount={5}
            description="This Weeks"
            Icon={TrendingUp}
            variant="emerald"
          />
          <SummaryCard
            dispalyCount={210}
            description="Total Likes"
            Icon={Heart}
            variant="pink"
          />
          <SummaryCard
            dispalyCount={6}
            description="Categories"
            Icon={Award}
            variant="amber"
          />
        </div>
        <FilterToolBar
          filters={recognitionFilters}
          activeFilter={activeFilter}
          onFilterChange={setActiveFilter}
          onActionClick={handleOpenShoutout}
        />
        {isShoutoutOpen && (
          <ShoutoutCard
            onClose={handleCloseShoutout}
            recordId="0"
          />
        )}
        <div className="space-y-4">
          {recordList && recordList.length > 0 ? (
            recordList.map((shoutout) => 
              <RecognitionCard 
                key={shoutout.rcw_id}
                recordData={shoutout}
                rcw_id={shoutout.rcw_id}
              />)
            ) : (
            <div className="text-center py-12">
              <GraduationCap className="w-12 h-12 text-slate-700 mx-auto mb-4"/>
              <p className="text-slate-700">No courses found matching the filters</p>
            </div>
					)}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.recognitionWall.recognitionWallList?.items,
  pagination: state.recognitionWall.recognitionWallList?.pagination,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getRecognitionWallList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Recognitions);